import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import './regulation.css';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Regulation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>特定商取引法に基づく表記 | 株式会社TERRA</title>
      </Helmet>
      <div className="regulation" style={{ background: 'rgb(235, 244, 246)' }}>
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          特定商取引法に基づく表記
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>特定商取引法に基づく表記</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container my-5 py-2" style={{ background: 'white' }}>
          <p className="text_title">販売者</p>
          <p>
            株式会社TERRA
          </p>
          <p className="text_title">運営責任者</p>
          <p>代表取締役　廣川 正秋</p>
          <p className="text_title">所在地</p>
          <p>
            〒 107-0051
            <br />
            東京都港区元赤坂 1-7-18
            <br />
            メットライフ元赤坂イースト 7F
            <br />
            TEL 03-6812-9104
            <br />
            FAX 03-6812-9105
          </p>
          <p className="text_title">連絡先</p>
          <p>
            <ul>
              <li>本社代表電話 : 03-6812-9104</li>
              <li>FAX : 03-6812-9105</li>
              <li>メールアドレス : info@terra-group.co.jp</li>
            </ul>
          </p>
          <p className="text_title">商品価格</p>
          <p>商品ごとに掲載。該当ページで販売価格を表示。</p>
          <p className="text_title">商品価格</p>
          <p>
            <ul>
              <li>消費税</li>
              <li>送料</li>
            </ul>
          </p>
          <p className="text_title">代金引換手数料</p>
          <p>
            ヤマト運輸株式会社の代金引換決済サービス手数料に準拠
            <br />
            <a href="https://business.kuronekoyamato.co.jp/service/lineup/payment_daibiki/index.html">https://business.kuronekoyamato.co.jp/service/lineup/payment_daibiki/index.html</a>
          </p>
          <p className="text_title">送料</p>
          <p>
            2,200円未満の商品のみご購入の場合：405円
            <br />
            それ以外の場合：1,200円
            <br />
            ※商品を同時に5つ以上ご購入の場合は送料が倍になります。
          </p>
          <p className="text_title">支払い方法</p>
          <p>
            クレジットカード
            <br />
            代金引換
          </p>
          <p className="text_title">支払期限</p>
          <p>
            【クレジットカード】
            <br />
            定期便：初回購入時、次月以降毎月25日
            <br />
            単　品：購入時
            <br />
            【代金引換】
            <br />
            定期便・単品：商品到着時
          </p>
          <p className="text_title">商品の引渡し時期</p>
          <p>
            お申し込み後、お客様と日時打ち合わせの上、ご指定日にお届けします。
            <br />
            次月以降、定期便はご契約期間中、毎月10日に発送します。
          </p>
          <p className="text_title">返品・不良品交換・解約</p>
          <p>
            万が一ご注文と異なる商品・不良品等が届いた場合、商品到着後8日以内にご返品ください。
            <ul style={{ marginBottom: '0' }}>
              <li>返品送料は弊社負担になります。</li>
              <li>品質不良による返品送料も弊社負担になります。</li>
              <li>商品本体の不具合に関しましては無料交換いたします。</li>
            </ul>
            ※ 但し、お客様の原因による破損等が生じた場合、返品・交換等にかかる費用はお客様負担とさせていただきます。
            <br />
            <br />
            定期便のご利用中止は、フリーダイヤルのコールセンターにご連絡ください。
            <br />
            ※お申し込み後の撤回は不可です。
            <br />
            ※ご解約はいつでも可能です。
          </p>
          <br />
          <br />
          <p className="text-center font-weight-bold phone_number" style={{ fontSize: '4rem', letterSpacing: '0.5rem', lineHeight: '1' }}>0120-406-520</p>
          <p className="text-center phone_time" style={{ fontSize: '1.5rem', letterSpacing: '0.2rem' }}>24時間365日対応</p>
        </div>
      </div>
    </TheLayout>
  );
};

export default Regulation;
